import { Children, useReducer } from 'react'
import { useTheme } from '@nfinite/react-hubstairs/styled/theme'

import { GridContainer, ToggleCollapse, Collapse, CollapseContent, CollapseItem } from './styled'
import { useTableRow } from 'components/Commons/TableRow/Provider'
import Link from 'components/Router/Link'

export function getMobileItems(items) {
  return items.filter(({ size }) => !!size.mobile).map(item => ({ ...item, size: item.size.mobile }))
}

export function getDesktopItems(items) {
  return items.map(item => ({ ...item, size: item.size.desktop ?? item.size }))
}

export function getTemplate(items) {
  return items.map(({ size }) => size).join(' ')
}

function TableRowDesktop({ tableItems, rowHeight, link, linkTo, className, children, onClick, dataTestId }) {
  const items = getDesktopItems(tableItems)
  return (
    <GridContainer
      data-testid={dataTestId}
      as={link || linkTo ? Link : 'div'}
      to={link}
      navigateTo={linkTo}
      rowHeight={rowHeight}
      template={getTemplate(items)}
      className={className}
      onClick={onClick}
    >
      {children}
    </GridContainer>
  )
}

function TableRowMobile(props) {
  const { mutilple = false } = props

  if (mutilple) {
    return <TableRowMobileMultiple {...props} />
  } else {
    return <TableRowMobileSingle {...props} />
  }
}

function TableRowMobileSingle(props) {
  const [open, toggleOpen] = useReducer(o => !o, false)

  return <TableRowMobileContent {...props} open={open} toggleOpen={toggleOpen} />
}

function TableRowMobileMultiple(props) {
  const { open, toggleOpen } = useTableRow()
  return <TableRowMobileContent {...props} open={open} toggleOpen={toggleOpen} />
}

function TableRowMobileContent({
  tableItems,
  rowHeight,
  link,
  linkTo,
  className,
  children,
  showToggle = true,
  open,
  toggleOpen,
}) {
  const items = getMobileItems(tableItems)

  // The last column is for the collapse toggle
  const sliceOnMobile = items.length - 1

  const childrenArray = Children.toArray(children)
  const display = childrenArray.slice(0, sliceOnMobile)
  const inCollapse = childrenArray.slice(sliceOnMobile, childrenArray.length)

  return (
    <GridContainer
      as={link || linkTo ? Link : 'div'}
      to={link}
      navigateTo={linkTo}
      rowHeight={rowHeight}
      template={getTemplate(items)}
      extraRows={open ? 1 : 0}
      className={className}
    >
      {display}
      {showToggle && (
        <ToggleCollapse.Wrapper onClick={toggleOpen}>
          <ToggleCollapse open={open}>
            <ToggleCollapse.Dash />
            <ToggleCollapse.Dash />
          </ToggleCollapse>
        </ToggleCollapse.Wrapper>
      )}
      <Collapse isOpen={open}>
        <CollapseContent>
          {inCollapse.map((item, index) => {
            const { element, key } = tableItems[index + sliceOnMobile]
            return (
              <CollapseItem key={key}>
                {element && <CollapseItem.Label>{element}</CollapseItem.Label>}
                {item}
              </CollapseItem>
            )
          })}
        </CollapseContent>
      </Collapse>
    </GridContainer>
  )
}

function TableRow(props, dataTestId) {
  const { isMobile } = useTheme({ watchMobile: true })
  return isMobile ? <TableRowMobile {...props} /> : <TableRowDesktop dataTestId={dataTestId} {...props} />
}

export const TableHeader = GridContainer

export default TableRow
